import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import * as R from 'ramda';
import { Trans, withTranslation } from 'react-i18next';
import { pageWrapper, EEventNames } from '../../../../../client/analytics';
import Container from '../../../../common/components/container';
import Overview from '../../../../common/components/overview';
import { Table, TableDropdown } from '../../../../common/components/table';
import { Button } from '../../../../common/components/button';
import Icon from '../../../../common/components/icon';
import Tooltip from '../../../../common/components/tooltip';
import Permission from '../../../../common/components/permission';
import FunctionModal from '../../../admin/components/function';
import FunctionForm from '../../forms/function';
import * as organisationSelector from '../../../organisation/selectors/organisation';
import * as networkSelector from '../../selectors/network';
import { EPermissions } from '../../../../common/definitions';

const columns = [
  {},
  { className: 'Table__Cell--clickable' },
];

const NetworkSettingsFunctions = ({
  organisation, network, functions, fetchFunction, t,
}) => {
  const [editing, setEditing] = React.useState(null);

  const editingFunction = editing && R.find(R.propEq('id', editing), functions);

  return (
    <Container name="SettingsAdmins">
      <Container.Content>
        <Overview>
          {editingFunction && (
            <FunctionForm
              form={`edit-function-${editingFunction.id}`}
              organisation={organisation}
              network={network}
              function={editingFunction}
              onClose={() => setEditing(null)}
            />
          )}
          <Overview.Header>
            <Overview.Header.Title><Trans i18nKey="network:settings_functions_title" /></Overview.Header.Title>
            <Permission name={EPermissions.TEST} fallback>
              {' '}
              {/* TODO */}
              <div className="pull-right">
                <Tooltip
                  placement="left"
                  title={t('network:settings_functions_add_no_rights_title')}
                >
                  <Button type="primary" size="large" iconRight="add" disabled>
                    <Trans i18nKey="network:settings_functions_add_no_rights_disabled_button" />
                  </Button>
                </Tooltip>
              </div>
            </Permission>
          </Overview.Header>
          <Overview.Content>
            <Table
              hideHeader
              columns={columns}
              items={functions}
              renderRow={({ item }) => [
                <div>
                  {item.name}
                  {item.external_id && organisation?.integrations?.length ? (
                    <small className="AlertText">
                      <Icon type="sync_alt" />
                      <span>
                        <Trans
                          i18nKey="network:settings_functions_synchronized"
                          values={{
                            integrationName: t('organisation:integration_label'),
                          }}
                          components={[<b>a</b>]}
                        />
                      </span>
                    </small>
                  ) : null}
                </div>,
                <FunctionModal network={network} function={item}>
                  <small><Trans i18nKey="network:settings_functions_employee_count" values={{ count: item.users_count }} /></small>
                </FunctionModal>,
              ]}
              placeholder={(
                <small className="Table__Placeholder"><Trans i18nKey="network:settings_functions_placeholder" /></small>
              )}
              ActionComponent={({ item }) => (
                <TableDropdown id="function-actions-dropdown" disabled={!!item.external_id}>
                  <TableDropdown.Item
                    onClick={async () => {
                      await fetchFunction(item.id);

                      setEditing(item.id);
                    }}
                  >
                    <Trans i18nKey="network:function_actions_edit" />
                  </TableDropdown.Item>
                </TableDropdown>
              )}
            />
          </Overview.Content>
        </Overview>
      </Container.Content>
    </Container>
  );
};

NetworkSettingsFunctions.propTypes = {
  organisation: PropTypes.object.isRequired,
  network: PropTypes.object.isRequired,
  functions: PropTypes.array.isRequired,
  fetchFunction: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  organisation: organisationSelector.selected(state),
  network: networkSelector.selected(state),
  functions: networkSelector.functions(state),
});

const mapDispatchToProps = {
  fetchFunction: require('../../actions').fetchFunction,
};

const ConnectedNetworkSettingsFunctions = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(
    pageWrapper(EEventNames.VISITED_NETWORK_FUNCTIONS_SETTINGS_PAGE)(
      NetworkSettingsFunctions,
    ),
  ),
);

export default ConnectedNetworkSettingsFunctions;
